import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { CmmOrderTableRowData } from "../../../../data-model/cmmOrderTableRowData";
import { ModalId } from "../../../../enums/modalId";
import { CopyIcon } from "../../../../svg/copy-icon";
import { calculateAge } from "../../../../utils/ageCalculator";
import SideNavElement from "../../../sideNavElement/sideNavElement";
import ClinicalAttachement from "./components/clinicalAttachement";
import SecondaryDiagnosisCodes from "./components/secondaryDiagnosisCodes";

interface ExpandableTableRowSecondaryDiagnosisProps {
  onClose: () => void;
  rowData?: CmmOrderTableRowData;
}

const tabs = [
  { id: "diagnosis-codes", label: "Diagnosis Codes" },
  { id: "clinical-attachments", label: "Clinical Attachments" },
];

const ExpandableTableRowSecondaryDiagnosis = ({
  onClose,
  rowData,
}: ExpandableTableRowSecondaryDiagnosisProps) => {
  const [selectedTab, setSelectedTab] = useState<string>("diagnosis-codes");

  const renderContent = () => {
    switch (selectedTab) {
      case "diagnosis-codes":
        return <SecondaryDiagnosisCodes rowData={rowData} />;
      case "clinical-attachments":
        return <ClinicalAttachement rowData={rowData} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      dialogId={ModalId.EXPANDABLE_TABLE_ROW_SECONDARY_DIAGNOSIS_MODAL}
      onSave={onClose}
      title={"Diagnosis"}
      saveButtonText={"Close"}
      cancelText={"Cancel"}
      onCancel={onClose}
      onClose={onClose}
      heightPercentage={90}
      showSingleButton={true}
      hideFooter={true}
    >
      <div className="flex h-full w-full flex-col">
        <div className="flex w-full items-center gap-2 border-b border-primaryGray-15 pb-3">
          <div className="mx-2 rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
            {rowData?.patientDetails?.mainText ?? "N/A"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.patientId ?? "N/A"}
            &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.dateOfBirth?.mainText ?? "N/A"} (
            {calculateAge(rowData?.dateOfBirth?.mainText)} yrs) &nbsp;&nbsp;
            <span>&#8226;</span>&nbsp;&nbsp;
            {rowData?.medication?.split(" ")[0] ?? "N/A"}
          </div>
          <div className="rounded-[1.875rem] bg-primaryGray-16 px-4 py-1 text-small font-semibold leading-6 text-primaryGray-1">
            {rowData?.type ?? "N/A"}
          </div>
          <div className="cmm-result-key mx-2 ml-auto flex items-center gap-2 text-small">
            CMM Key:{" "}
            <span className="font-bold">
              {rowData?.cmmKey ?? "N/A"}
              &nbsp;
            </span>
            <div
              className="cmm-result-key copy-icon hover:cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(rowData?.cmmKey ?? "");
              }}
            >
              <CopyIcon />
            </div>
          </div>
        </div>

        <div className="flex flex-1 gap-1 overflow-hidden">
          <div className="side-nav--container flex w-[20%] flex-col overflow-y-auto">
            {tabs.map((tab) => (
              <SideNavElement
                key={tab.id}
                id={tab.id}
                label={tab.label}
                active={tab.id === selectedTab}
                onSelect={(id) => setSelectedTab(id)}
              />
            ))}
          </div>
          <div className="content--container flex h-full w-[80%] flex-1 flex-col bg-primaryGray-16">
            {renderContent()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExpandableTableRowSecondaryDiagnosis;
